import { render, staticRenderFns } from "./EditBasePersonne.vue?vue&type=template&id=a0a8b85a&"
import script from "./EditBasePersonne.vue?vue&type=script&lang=ts&"
export * from "./EditBasePersonne.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VAlert,VForm})
